/** The primary chat pane has committed its first ready transcript render. */
export const CHAT_ROUTE_READY_EVENT = "openclaw-chat-route-ready";

/** Dispatched by a pane whenever its authoritative transcript starts or stops loading. */
export const CHAT_TRANSCRIPT_LOADING_CHANGED_EVENT = "openclaw-chat-transcript-loading-changed";

/** Pane membership or conversation presentation changed, including a detached loading pane. */
export const CHAT_PANE_LIFECYCLE_CHANGED_EVENT = "openclaw-chat-pane-lifecycle-changed";

/** A pane entered or left transient history/subscription recovery. */
export const CHAT_HISTORY_RECOVERY_CHANGED_EVENT = "openclaw-chat-history-recovery-changed";

/** Run activity stays observable while hidden panes defer their Lit render. */
export const CHAT_RUN_ACTIVITY_CHANGED_EVENT = "openclaw-chat-run-activity-changed";
